import React, {Component} from "react";
import { observer, inject } from "mobx-react";
import { Navigate } from "react-router";

import { TicketStore, ReportStore } from "../../stores";
import { Ticket } from "Stores/dashboardStore/tickets";
import { ActionPlanSearchFilters } from "./TicketSearchForm";

import { TicketList } from "../Tickets/List";
import { ReportGenerationForm } from "./GenerationForm";
import { Utils } from "../../common/utils";

export interface TicketSelectionProps {
    ticketStore?: TicketStore
    reportStore?: ReportStore
    onNewSearch?: (fn: () => void) => void
    selectedTicketsPageSize?: number
    searchResultsPageSize?: number
    searchFilters?: ActionPlanSearchFilters
}

interface TicketSelectionState {
    selectedTickets?: Ticket[]
    shouldShowGenerateModal: boolean
    redirectToList: boolean
}

@inject("reportStore", "ticketStore")
@observer
export class TicketSelector extends Component<TicketSelectionProps, TicketSelectionState> {

    onNewSearch = () => {};

    constructor(props: TicketSelectionProps) {
        super(props);
        if (this.props.onNewSearch) {
            this.props.onNewSearch(this.newSearch);
        }
    }

    state = {
        shouldShowGenerateModal: false,
        redirectToList: false
    };

    newSearch = () => {
        /* turtles all the way down */
        this.onNewSearch();
    };

    handleSelect = ({original}: {original: Ticket}) => {
        if ( !this.props.reportStore || !this.props.ticketStore ) return;
        this.props.reportStore.toggleTicket(original);
        this.props.ticketStore.toggleSelectionById(original.ruuid);
    };

    handleSelectAll = ( isSelected: boolean, tickets: Ticket[] ) => {
        if ( !this.props.reportStore || !this.props.ticketStore ) return;
        this.props.reportStore.setTicketSelection(isSelected ? tickets : []);
        this.props.ticketStore.setSelectionAll(isSelected);
    };

    toggleGenerateReport = (shouldRedirect?: boolean) => {
        this.setState({
            shouldShowGenerateModal: !this.state.shouldShowGenerateModal,
            redirectToList: shouldRedirect ? shouldRedirect : false
        });
    };

    render () {
        if ( !this.props.reportStore ) return null;
        if (this.state.redirectToList) {
            return <Navigate to={ `${Utils.getLinkBase()}/reports` } />;
        }
        return (
            <div id="selectionLists" className="reports-list-container">
                {/* chosen tickets */}
                <TicketList
                    key={this.props.reportStore.selectedTickets ? this.props.reportStore.selectedTickets.length : 0}
                    generateReport={ this.toggleGenerateReport }
                    pageSize={this.props.selectedTicketsPageSize || 6}
                    tickets={ this.props.reportStore.selectedTickets ? this.props.reportStore.selectedTickets : [] }
                    isReporting={true}
                    selectTicket={ this.handleSelect }
                    selectAllTickets={ this.handleSelectAll } />
                {/* tickets from search results */}
                <TicketList
                    key="all"
                    isReporting={true}
                    pageSize={this.props.searchResultsPageSize || 40}
                    selectTicket={ this.handleSelect }
                    selectAllTickets={ this.handleSelectAll }
                    searchFilters={ this.props.searchFilters }
                    onNewSearch={(onNewSearch: () => void) => this.onNewSearch = onNewSearch}/>
                { this.state.shouldShowGenerateModal ? <ReportGenerationForm isModal={true} handleCloseModal={ this.toggleGenerateReport } numberOfTix={ this.props.reportStore.selectedTickets.length } /> : null}
            </div>
        );
    }

}
